<template>
  <img
    :src="src"
    :alt="alt"
    :title="title"
    :width="width"
    :height="height"
    :class="className"
    :style="imgStyle"
    loading="lazy"
    @error="handleError"
  />
</template>

<script>
export default {
  name: 'ResponsiveImage',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: null
    },
    className: {
      type: String,
      default: ''
    },
    imgStyle: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleError(e) {
      // Replace broken images with fallback
      e.target.src = require('@/assets/img/error.png');
      this.$emit('error', e);
    }
  }
}
</script>

<style scoped>
img {
  max-width: 100%;
  height: auto;
  transition: opacity 0.3s ease;
}
</style> 


// WEBPACK FOOTER //
// src/components/ResponsiveImage.vue